module.exports = __webpack_public_path__ + "files/SPIADI2026 - Procédure envoi fichier import.ef37442d8388f7578368d41036d85f98.pdf";